import { debounce, orderBy } from "lodash";
import cloneDeep from "lodash/cloneDeep";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";

import KisList from "@/components/KIS/KisList/KisList.vue";
import KisDepartmentEditDialog from "@/components/KIS/KisDepartmentEditDialog/KisDepartmentEditDialog.vue";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

const defaultItem = {
  name: "",
  address: {},
  links: [],
  description: "",
  active: true
};

export default {
  name: "KisDepartmentList",
  components: {
    KisDepartmentEditDialog,
    KisList
  },
  data: () => ({
    manualSlug: false,
    loading: false,
    editedItem: {},
    editDialog: false,
    viewLog: null,
    filter: { name: "", limit: 10 },
    headers: [
      { text: "Name", value: "name" },
      { text: "Zuletzt geändert am", value: "updatedAt" },
      { text: "Aktiv", value: "active" },
      { text: "Aktionen", sortable: false, value: "actions" }
    ]
  }),
  async mounted() {
    this.loading = true;
    const itemsPerPage = this.itemsPerPage;
    if (itemsPerPage && !isNaN(itemsPerPage)) {
      this.filter.limit = itemsPerPage;
      this.filter.itemsPerPage = itemsPerPage;
      this.itemsPerPage = itemsPerPage;
    }
    await this.$store.dispatch("getDepartments", this.filter);
    await this.getAllPersons();
    await this.$store.dispatch("getSubjectAreas");
    await this.$store.dispatch("getAllUsers");
    await this.$store.dispatch("getFacilities");

    this.loading = false;
  },
  methods: {
    async getAllPersons() {
      const limit = 100;

      await this.$store.dispatch("getPersons", {
        skip: this.persons.length,
        limit,
        getAll: true
      });
    },
    editItem(item) {
      this.editDialog = true;
      this.editedItem = cloneDeep(item);
    },
    addNewDepartment() {
      this.editedItem = cloneDeep(defaultItem);
      this.editedItem.principal_id = this.currentPrincipal;
      this.editDialog = true;
    },
    async closeDialog() {
      this.editedItem = cloneDeep(defaultItem);
      this.editDialog = false;
      await this.$store.dispatch("getDepartments", this.filter);
    },
    copyItem(item) {
      this.editedItem = cloneDeep(item);
      delete this.editedItem?._id;
      this.editDialog = true;
    },
    setDepartment(item) {
      this.editedItem = item;
    },
    setFilterPage(page) {
      this.filter.page = page;
    },
    setFilterLimit(limit) {
      this.filter.limit = limit;
      this.filter.itemsPerPage = limit;
      localStorage.setItem("itemsPerPage", limit);
    },
    async getDepartments(filter) {
      await this.$store.dispatch("getDepartments", filter);
    },
    async updateDepartment(department) {
      try {
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.kis_api_client_url}department/${department._id}`,
          department,
          {
            params: {
              principal_id: department.principal_id
            },
            headers
          }
        );
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          this.setDepartment(response.data);
          await this.$store.dispatch("getDepartments", this.filter);
        } else {
          console.error(response);
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten!"
          );
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    async deleteDepartment(department) {
      try {
        const confirm = await this.$confirm(
          "Möchten Sie diesen Geschäftsbereich wirklich löschen?",
          confirmWarningConfig
        );
        if (confirm) {
          const headers = getTokenHeader();
          if (!this.editedItem.principal_id)
            this.editedItem.principal_id = this.currentPrincipal;
          const response = await axios.delete(
            `${env.kis_api_client_url}department/${department._id}`,
            {
              params: {
                principal_id: department.principal_id
              },
              headers
            }
          );
          if (response.status === 200) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gelöscht!"
            );
            await this.$store.dispatch("getDepartments", this.filter);
          } else {
            console.error(response);
            await this.$store.dispatch(
              "createError",
              "Es ist ein Fehler aufgetreten!"
            );
          }
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    applySearchText: debounce(async function() {
      if (this.filter.name.length >= 3 || !this.filter.name.length)
        await this.$store.dispatch("getDepartments", this.filter);
    }, 500)
  },
  computed: {
    personCount() {
      return this.$store.state.personCount;
    },
    departmentCount() {
      return this.$store.state.departmentCount;
    },
    departments() {
      return this.$store.state.departments;
    },
    persons() {
      return orderBy(this.$store.state.persons, "firstName");
    },
    subjectAreas() {
      return this.$store.state.subjectAreas?.map(area => ({
        ...area,
        title: area.name
      }));
    },
    facilities() {
      return this.$store.state.facilities.map(facility => ({
        ...facility,
        title: facility.name
      }));
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    }
  }
};
